import module from 'fanconsultores/module.js'

class FanSharedLanguageStorageService {
  constructor ($localStorage) {
    this.$localStorage = $localStorage
  }

  get (name) {
    if (!this.$localStorage[name]) {
      this.$localStorage[name] = 'es_MX'
    }

    return this.$localStorage[name]
  }

  put (name, value) {
    this.$localStorage[name] = value
  }
}

module.service('FanSharedLanguageStorage', FanSharedLanguageStorageService)



// WEBPACK FOOTER //
// ./src/fanconsultores/services/Shared/Language/Storage.js